import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(10, 20),
  gap: 20,
  width: "100%",
  backgroundColor: theme.palette.white,
  boxShadow: `0 1px 5px ${theme.palette.shadow.medium}`,
  borderRadius: "8px",

  [theme.down("sm")]: {
    ...theme.paddings(10),
  },
}));
